
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/highlightResize/resizeHighlight.scss.css.virtualfile';
        module.exports = {"highlightedBox":"_highlightedBox_1fqk2_7","blinkAnimation":"_blinkAnimation_1fqk2_1"};